import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import { useDateFnsLocaleEffect } from 'i18n/date-fns';
import { useDateDayjsLocaleEffect } from 'i18n/dayjs';
import { AiAssistantProvider } from 'lib/ai-assistant';
import { ConfigProvider } from 'lib/antd';
import { AuthAdapter } from 'lib/client-auth';
import { UploadProvider } from 'lib/media-upload-file';
import { RichTextEditorProviderLicenseGate } from 'lib/react-rich-text-editor';
import { queryClient } from 'query';
import { Router } from 'routes';
import { FormItemProvider } from 'ui';

// eslint-disable-next-line react/function-component-definition -- Vite require this
export default function App() {
  useDateFnsLocaleEffect();
  useDateDayjsLocaleEffect();

  return (
    <ConfigProvider>
      <GoogleOAuthProvider clientId={String(import.meta.env.VITE_APP_GOOGLE_CLIENT_ID)}>
        <AuthAdapter>
          <RichTextEditorProviderLicenseGate>
            <QueryClientProvider client={queryClient}>
              <FormItemProvider>
                <UploadProvider>
                  <AiAssistantProvider>
                    <Router />
                  </AiAssistantProvider>
                </UploadProvider>
              </FormItemProvider>
            </QueryClientProvider>
          </RichTextEditorProviderLicenseGate>
        </AuthAdapter>
      </GoogleOAuthProvider>
    </ConfigProvider>
  );
}
